import { formatFullName } from '../../utils/personName';
import { calculateAgeFromCalendarYmd } from '../../utils/dateTimeUtils';
import { getAgeGroupSelectOptions } from '../../constants/ageGroups';

/** Current lead form age-group options (canonical five + leftover stored value). */
export function getLeadAgeGroupSelectOptions(currentValue) {
  return getAgeGroupSelectOptions(currentValue);
}

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function formatLeadParentDisplayName(lead) {
  if (!lead) return 'Unknown lead';
  const contact = formatFullName(lead.parent_first_name, lead.parent_last_name);
  const parent = contact || (lead.mother_name || lead.father_name || '').trim();
  const child = `${lead.first_name || ''} ${lead.last_name || ''}`.trim();
  if (parent && child) return `${parent} (child: ${child})`;
  if (parent) return parent;
  if (child) return child;
  return lead.display_id || lead.phone || 'Unknown lead';
}

/** Numeric age, else age from date of birth, else age-group label, else null */
export function formatChildAgeLabel(lead) {
  if (lead?.age != null && lead.age !== '') return String(lead.age);
  const fromDob = calculateAgeFromCalendarYmd(lead?.date_of_birth);
  if (fromDob != null) return String(fromDob);
  if (lead?.age_group) return String(lead.age_group);
  return null;
}

export function formatChildAgeForDemo(lead) {
  return formatChildAgeLabel(lead) || 'N/A';
}

export function formatLeadTimePreferences(preferences) {
  if (!preferences?.length) return null;
  return preferences
    .map((p) => {
      const day = DAY_NAMES[p.day_of_week] ?? `Day ${p.day_of_week}`;
      const start = p.start_time ? String(p.start_time).slice(0, 5) : '';
      const end = p.end_time ? String(p.end_time).slice(0, 5) : '';
      return `${day}: ${start}–${end}`;
    })
    .join('; ');
}

export function formatListDisplay(value) {
  if (value == null) return null;
  if (Array.isArray(value)) {
    const filtered = value.filter(Boolean);
    return filtered.length ? filtered.join(', ') : null;
  }
  const s = String(value).trim();
  return s === '' ? null : s;
}
